/*
 * VDC Shipment Protection - RETIRED 2026-06-10 (v3, inert).
 * Redo enabled THEIR official checkout-plus integration for this store during the
 * 2026-06-10 call: a <redo-shopify-toggle> component that anchors to the theme's native
 * [name="checkout"] button and renders "Checkout+ | $total" plus a "checkout without
 * free returns & package protection" link. Protection add, price tiering, the
 * redo_treatment_id attribute, and coverage are all handled by Redo's own component,
 * so the VDC implementation (v1 toggle, v2 checkout-choice buttons) is fully retired.
 * This file is kept as an inert stub because sections/cart-drawer.liquid still loads it.
 * History (tier formula, treatment attribute, product identities) lives in the project
 * memory notes if a theme-side fallback is ever needed again.
 */
(function () { 'use strict'; })();
